
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93w3CdIPjClmMeta } from "/tmp/menaceking-build-1752223655/pages/[...slug].vue?macro=true";
import { default as autologinl9nst1LzgXMeta } from "/tmp/menaceking-build-1752223655/pages/auth/autologin.vue?macro=true";
import { default as callbackcIVfYA1OZLMeta } from "/tmp/menaceking-build-1752223655/pages/auth/social/[connection]/callback.vue?macro=true";
import { default as betting694EcFuWs8Meta } from "/tmp/menaceking-build-1752223655/pages/betting.vue?macro=true";
import { default as _91pageIdentity_936nwyZdQtIrMeta } from "/tmp/menaceking-build-1752223655/pages/bonus/[pageIdentity].vue?macro=true";
import { default as _91categoryIdentity_93hEn3mQVgRPMeta } from "/tmp/menaceking-build-1752223655/pages/categories/[categoryIdentity].vue?macro=true";
import { default as categoriesKGkexolnCzMeta } from "/tmp/menaceking-build-1752223655/pages/categories.vue?macro=true";
import { default as contactxiZOxmEybzMeta } from "/tmp/menaceking-build-1752223655/pages/contact.vue?macro=true";
import { default as favorites_46clienthIWhBFk7pfMeta } from "/tmp/menaceking-build-1752223655/pages/favorites.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/tmp/menaceking-build-1752223655/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91id_93EnAvKEbpKsMeta } from "/tmp/menaceking-build-1752223655/pages/games/[id].vue?macro=true";
import { default as indexwodgnfAITBMeta } from "/tmp/menaceking-build-1752223655/pages/index.vue?macro=true";
import { default as loyaltyRuqgJuBbV5Meta } from "/tmp/menaceking-build-1752223655/pages/loyalty.vue?macro=true";
import { default as mainSGZuM6ez32Meta } from "/tmp/menaceking-build-1752223655/pages/main.vue?macro=true";
import { default as bonusesvrhtyuvHc1Meta } from "/tmp/menaceking-build-1752223655/pages/profile/bonuses.vue?macro=true";
import { default as documentsCdMsOWv8qoMeta } from "/tmp/menaceking-build-1752223655/pages/profile/documents.vue?macro=true";
import { default as history2CHCqf7NXIMeta } from "/tmp/menaceking-build-1752223655/pages/profile/history.vue?macro=true";
import { default as infoc8wLOCEeQKMeta } from "/tmp/menaceking-build-1752223655/pages/profile/info.vue?macro=true";
import { default as limits8Ss3RwhIaUMeta } from "/tmp/menaceking-build-1752223655/pages/profile/limits.vue?macro=true";
import { default as notificationsUhg3stq1s5Meta } from "/tmp/menaceking-build-1752223655/pages/profile/notifications.vue?macro=true";
import { default as securityEiJaW7qk0eMeta } from "/tmp/menaceking-build-1752223655/pages/profile/security.vue?macro=true";
import { default as verificationhZhxRe7nZXMeta } from "/tmp/menaceking-build-1752223655/pages/profile/verification.vue?macro=true";
import { default as walletHuwV8xNCveMeta } from "/tmp/menaceking-build-1752223655/pages/profile/wallet.vue?macro=true";
import { default as profile_46clientdjvREtsvEpMeta } from "/tmp/menaceking-build-1752223655/pages/profile.client.vue?macro=true";
import { default as providersYOqDF60AMlMeta } from "/tmp/menaceking-build-1752223655/pages/providers.vue?macro=true";
import { default as _91pageIdentity_93IwKm1hs85HMeta } from "/tmp/menaceking-build-1752223655/pages/questions/[pageIdentity].vue?macro=true";
import { default as questionsdIahQSyIisMeta } from "/tmp/menaceking-build-1752223655/pages/questions.vue?macro=true";
import { default as recently_45played_46client1ugoPu6NS5Meta } from "/tmp/menaceking-build-1752223655/pages/recently-played.client.vue?macro=true";
import { default as _91pageIdentity_93jOpsZNloUeMeta } from "/tmp/menaceking-build-1752223655/pages/static/[pageIdentity].vue?macro=true";
import { default as _91identity_93cL2CSDd4xxMeta } from "/tmp/menaceking-build-1752223655/pages/tournaments/[identity].vue?macro=true";
import { default as index2dhJhjfYAfMeta } from "/tmp/menaceking-build-1752223655/pages/tournaments/index.vue?macro=true";
import { default as welcome_45package1VDfdpOftNMeta } from "/tmp/menaceking-build-1752223655/pages/welcome-package.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/tmp/menaceking-build-1752223655/pages/[...slug].vue")
  },
  {
    name: "auth-autologin",
    path: "/auth/autologin",
    component: () => import("/tmp/menaceking-build-1752223655/pages/auth/autologin.vue")
  },
  {
    name: "auth-social-connection-callback",
    path: "/auth/social/:connection()/callback",
    component: () => import("/tmp/menaceking-build-1752223655/pages/auth/social/[connection]/callback.vue")
  },
  {
    name: "betting",
    path: "/betting",
    component: () => import("/tmp/menaceking-build-1752223655/pages/betting.vue")
  },
  {
    name: "bonus-pageIdentity",
    path: "/bonus/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1752223655/pages/bonus/[pageIdentity].vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: categoriesKGkexolnCzMeta || {},
    component: () => import("/tmp/menaceking-build-1752223655/pages/categories.vue"),
    children: [
  {
    name: "categories-categoryIdentity",
    path: ":categoryIdentity()",
    component: () => import("/tmp/menaceking-build-1752223655/pages/categories/[categoryIdentity].vue")
  }
]
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/tmp/menaceking-build-1752223655/pages/contact.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1752223655/pages/favorites.client.vue"))
  },
  {
    name: "games-id",
    path: "/games/:id()",
    component: () => import("/tmp/menaceking-build-1752223655/pages/games/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/menaceking-build-1752223655/pages/index.vue")
  },
  {
    name: "loyalty",
    path: "/loyalty",
    component: () => import("/tmp/menaceking-build-1752223655/pages/loyalty.vue")
  },
  {
    name: "main",
    path: "/main",
    component: () => import("/tmp/menaceking-build-1752223655/pages/main.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1752223655/pages/profile.client.vue")),
    children: [
  {
    name: "profile-bonuses",
    path: "bonuses",
    component: () => import("/tmp/menaceking-build-1752223655/pages/profile/bonuses.vue")
  },
  {
    name: "profile-documents",
    path: "documents",
    component: () => import("/tmp/menaceking-build-1752223655/pages/profile/documents.vue")
  },
  {
    name: "profile-history",
    path: "history",
    component: () => import("/tmp/menaceking-build-1752223655/pages/profile/history.vue")
  },
  {
    name: "profile-info",
    path: "info",
    component: () => import("/tmp/menaceking-build-1752223655/pages/profile/info.vue")
  },
  {
    name: "profile-limits",
    path: "limits",
    component: () => import("/tmp/menaceking-build-1752223655/pages/profile/limits.vue")
  },
  {
    name: "profile-notifications",
    path: "notifications",
    component: () => import("/tmp/menaceking-build-1752223655/pages/profile/notifications.vue")
  },
  {
    name: "profile-security",
    path: "security",
    component: () => import("/tmp/menaceking-build-1752223655/pages/profile/security.vue")
  },
  {
    name: "profile-verification",
    path: "verification",
    component: () => import("/tmp/menaceking-build-1752223655/pages/profile/verification.vue")
  },
  {
    name: "profile-wallet",
    path: "wallet",
    component: () => import("/tmp/menaceking-build-1752223655/pages/profile/wallet.vue")
  }
]
  },
  {
    name: "providers",
    path: "/providers",
    component: () => import("/tmp/menaceking-build-1752223655/pages/providers.vue")
  },
  {
    name: "questions",
    path: "/questions",
    meta: questionsdIahQSyIisMeta || {},
    component: () => import("/tmp/menaceking-build-1752223655/pages/questions.vue"),
    children: [
  {
    name: "questions-pageIdentity",
    path: ":pageIdentity()",
    component: () => import("/tmp/menaceking-build-1752223655/pages/questions/[pageIdentity].vue")
  }
]
  },
  {
    name: "recently-played",
    path: "/recently-played",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1752223655/pages/recently-played.client.vue"))
  },
  {
    name: "static-pageIdentity",
    path: "/static/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1752223655/pages/static/[pageIdentity].vue")
  },
  {
    name: "tournaments-identity",
    path: "/tournaments/:identity()",
    component: () => import("/tmp/menaceking-build-1752223655/pages/tournaments/[identity].vue")
  },
  {
    name: "tournaments",
    path: "/tournaments",
    component: () => import("/tmp/menaceking-build-1752223655/pages/tournaments/index.vue")
  },
  {
    name: "welcome-package",
    path: "/welcome-package",
    component: () => import("/tmp/menaceking-build-1752223655/pages/welcome-package.vue")
  }
]